import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "mobile-home",
  "use": "mobile-home-usage",
  "viewBox": "0 0 27 27",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 27 27\" id=\"mobile-home\">\n    <g fill-rule=\"evenodd\">\n        <path fill=\"currentColor\" d=\"M14.676 4.202l7.606 4.85c.486.31.78.846.78 1.422V20.83c0 .932-.755 1.687-1.687 1.687h-6.73l.001-5.194h-1.709v5.194h-6.75c-.931 0-1.687-.755-1.687-1.687V10.328c0-.584.302-1.127.798-1.434L12.88 4.19c.55-.342 1.25-.337 1.796.011zm6.699 16.628V10.475l-7.606-4.849-7.581 4.703V20.83h5.062v-5.195h5.084v5.194h5.041z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol